import FieldConfig from "../../../proto/field-config";
import FieldString from "../../../generic/string/string";
import FieldProjectTotalOpenAll_TableCell from "./render/table-cell";


export default class FieldProjectTotalOpenAll extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Open / All";
        this.label      = "Open / All"

        this.renderComponents.tableCell = FieldProjectTotalOpenAll_TableCell
    }


}